/** Cheap / simplistic test to check if a string is a valid ASCII tab */
export function isAsciiTab(tab: string): boolean {
  const lines = tab.split('\n')
  return lines.filter(line => /^[eBGDAE]\|-.*\|/.test(line)).length >= 6
}
